// extracted by mini-css-extract-plugin
export default {"KbdShortcut":"KbdShortcut3gsETbU1kkU0"};